module.exports = __webpack_public_path__ + "img/home.07427e45.svg";